import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSetNotification } from '../../../context/Notification';
import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { MemberCreatePayload } from '../types';
import { ORGANIZATION_MEMBER_LIST_KEY } from './constants';

const useMemberCreate = (onSuccess?: () => void) => {
    const req = useRequest();
    const queryClient = useQueryClient();
    const setNotification = useSetNotification();

    const request = ({ payload }: { payload: MemberCreatePayload }) => {
        return req({
            url: `${envVars.API_RTM_HOSTNAME}enterprise/direct-enrollment/`,
            method: 'POST',
            body: JSON.stringify(payload)
        });
    };

    return useMutation({
        mutationFn: request,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [ORGANIZATION_MEMBER_LIST_KEY] });
            setNotification({ message: `Member Created` });
            onSuccess && onSuccess();
        },
        onError: (error?: { errors: string[] }) => {
            return error?.errors[0] || 'An error occurred while creating the member';
        }
    });
};

export default useMemberCreate;
